'use strict';

require('./date');
require('./range');

module.exports = require('sugar-core');


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/index.js
// module id = 303
// module chunks = 1